import React, { FunctionComponent, useEffect, useState } from 'react';
import { TOURIST_SERVICE_TYPE } from '../../../shared/constants';
import LocationFormField from '../location-form-field';
import ServicesListFormField from '../services-list-form-field';
import serviceDetailBaseStyles from '../../../styles/atoms/service-detail-base.module.scss';
import SchedulesSelectionFormField from '../schedules-selection-form-field';
import { getImageURL, splitField, splitFieldForms } from '../../../shared/utils';
import Icon from '../../base/icon';
import { useRouter } from 'next/router';
import { useTranslations } from 'next-intl';

type GastronomyPreviewProps = {
  detailData: any;
};

export const GastronomyPreview: FunctionComponent<GastronomyPreviewProps> = ({
  detailData,
}) => {
  const router = useRouter();
  const [locale, setLocale] = useState(router?.locale);
  const t = useTranslations('viewOffer');
  useEffect(() => {
    if(router.locale) {
      setLocale(router?.locale)
    }
  }, [router?.locale])
  
  return (
    <div className={serviceDetailBaseStyles.detailContainer}>

      <p>
        {t('especialidadComida')}{' '}
        <strong>
          {
            splitField(detailData.especialidad_comida, locale)
          }
        </strong>
      </p>


      <a
        className="btn yellow"
        href={getImageURL(detailData.url_menu)}
        target="_blank"
      >
        <Icon icon="download" size={20} />
        {t('descargarMenu')}
      </a>

      <div className={serviceDetailBaseStyles.field}>
        <p>{t('horario')}</p>
        <SchedulesSelectionFormField
          viewList={detailData?.horario_gastronomia}
          viewOnly={true}
        />
      </div>

      <div className={serviceDetailBaseStyles.field}>
        <p>{t('incluye')}</p>
        <ServicesListFormField
          value={detailData?.servicio_adicional_gastronomia}
          viewOnly={true}
          touristServiceType={TOURIST_SERVICE_TYPE.GASTRONOMY}
        />
      </div>
    </div>
  );
};
